module.exports = __webpack_public_path__ + "assets/img/Main material (8).6fea5b55.jpg";